import React from 'react';
import { unlocaliseUrl } from 'src/common/utils/format-localised-url';
import isEmpty from 'lodash/isEmpty';
import Icon from 'wonderbly-components/lib/Icon';
import PropTypes from 'prop-types';
import { allowEdit } from '../../../CartItems/LineItem/helpers';

const EditableLinks = (props) => {
  const hasGiftwrapAddons = !isEmpty(props.giftwrapAddons);
  const hasExtraAddons = !isEmpty(props.extraAddons);
  const isProductAvailable = !!props.fallbackProduct.response.ok;
  const countryModel = props.model.countryModel;

  return (
    <div className="line-item-ii-links">
      {/* Removing th edit button for TJH, MGT and TLB until the edit issue is resolved */}
      {allowEdit(props) && (
        <a
          // Check if the current product exists in the country that the user is in, there could be a chance that 
          // someone may have added a book to their cart and then changed their country.
          href={isProductAvailable ? props.editUrl : unlocaliseUrl(countryModel, props.editUrl)}
          className="line-item-ii-edit line-item-ii-edit--preview"
          onClick={props.onClickLink.editItem}>
          <Icon
            icon="write"
          />
          {' '}{props.editItemCta}
        </a>
      )}
      {props.giftwrapCta && (
        <a
          href={props.giftwrapCta.url}
          className="line-item-ii-edit line-item-edit--giftwrap"
          onClick={props.onClickLink[hasGiftwrapAddons ? 'editAddons' : 'addAddons']}>
          <Icon
            icon="gift"
          />
          {' '}{props.giftwrapCta[hasGiftwrapAddons ? 'edit' : 'add']}
        </a>
      )}
      {props.extrasCta && (
        <a
          href={props.extrasCta.url}
          className="line-item-ii-edit line-item-edit--extras"
          onClick={props.onClickLink[hasExtraAddons ? 'editAddons' : 'addAddons']}>
          <Icon
            icon="star"
          />
          {' '}{props.extrasCta[hasExtraAddons ? 'edit' : 'add']}
        </a>
      )}
    </div>
  );
};

EditableLinks.propTypes = {
  giftwrapAddons: PropTypes.array,
  extraAddons: PropTypes.array,
  extrasCta: PropTypes.shape({
    add: PropTypes.string.isRequired,
    edit: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
  giftwrapCta: PropTypes.shape({
    add: PropTypes.string.isRequired,
    edit: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
  editItemCta: PropTypes.string,
  isMobile: PropTypes.bool,
  onClickLink: PropTypes.shape({
    editItem: PropTypes.func.isRequired,
    editAddons: PropTypes.func.isRequired,
    addAddons: PropTypes.func.isRequired,
  }),
  editUrl: PropTypes.string.isRequired,
  model: PropTypes.shape({
    countryModel: PropTypes.object
  }),
  fallbackProduct: PropTypes.shape({
    response: PropTypes.object
  }),
  productKey: PropTypes.string,
};

export default EditableLinks;



// WEBPACK FOOTER //
// ./src/client/js/view/components/LineItemII/EditableContent/EditableLinks/EditableLinks.js